import { render, staticRenderFns } from "./ModalAjoutProduits.vue?vue&type=template&id=4363827e&"
import script from "./ModalAjoutProduits.vue?vue&type=script&lang=js&"
export * from "./ModalAjoutProduits.vue?vue&type=script&lang=js&"
import style0 from "./ModalAjoutProduits.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports